(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/company-details/constants.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/company-details/constants.js');

const actions = {
  RECEIVE_COMPANY_DETAILS: 'RECEIVE_COMPANY_DETAILS',
  UPDATE_ADDRESS: 'UPDATE_ADDRESS',
  UPDATE_CONTACT_PERSON: 'UPDATE_CONTACT_PERSON',
  EDIT_MODE: 'EDIT_MODE',
  EDIT_MODE_PASSWORD: 'EDIT_MODE_PASSWORD'
};

const TEXTS = {
  HEADER: 'Företagsuppgifter',
  EDIT_LABEL: 'Ändra uppgifter',
  CANCEL_LABEL: 'Avbryt',
  SAVE_LABEL: 'Spara',
  PASSWORD_LABEL: 'Ändra lösenord',
  SAVE_SUCCESS: 'Dina företagsuppgifter har uppdaterats',
  CONTACT_PERSON: {
    HEADER: 'Kontaktperson'
  },
  DELIVERY_ADDRESS: {
    HEADER: 'Leveransadress'
  },
  BILLING_ADDRESS: {
    HEADER: 'Fakturaadress'
  },
  COMPANY_ADDRESS_LEGAL: {
    HEADER: 'Företagsadress (juridisk)'
  },
  CHANGE_PASSWORD: {
    HEADER: 'Ändra lösenord',
    PASSWORD: '******'
  },
  INFO_TEXT: 'Beställer ni ett nytt engångslösenord via brev skickas det till företagets juridiska adress'
};

const names = {
  companyName: 'companyName',
  organizationNumber: 'organizationNumber',
  addresses: {
    addressType: 'addressType',
    contact: 'contact',
    phone: 'phone',
    email: 'email',
    address1: 'address1',
    address2: 'address2',
    zip: 'zip',
    city: 'city',
    countryId: 'countryId'
  },
  eMail: 'eMail',
  contactPerson: 'contactPerson',
  phone: 'phone',
  cellPhone: 'cellPhone'
};

const ADDRESS_TYPES = {
  VISITING: 'visiting',
  BILLING: 'billing',
  LEGAL: 'legal'
};

svs.ticket_partner.companyDetails.constants = {
  actions,
  TEXTS,
  names,
  ADDRESS_TYPES
};


 })(window);